import * as yup from 'yup';
import { TFunction } from 'i18next';

export const ForgotPasswordFormValidationSchema = (t: TFunction) => yup.object({
  email: yup
    .string()
    .email(t('emailIsNotValid') ?? '')
    .required(t('inputIsRequired') ?? ''),
});
